module.exports = __webpack_public_path__ + "static/media/upload-new.146f586a.svg";